import { DropdownList } from '@lightspeed/unified-components-helios-theme/react'
import type {
  DropdownListOption,
  UseDropdownListProps,
} from '@lightspeed/unified-react-components'
import type { ComponentProps, FC, RefObject } from 'react'

export const AVAILABILITY_BADGE_APPEARANCES = {
  danger: 'danger',
  warning: 'warning',
  success: 'success',
} as const

export type OutletOption = {
  id: string
  name: string
  address?: string
  available?: number
}

export type OutletSelectProps = {
  disabled?: boolean
  className?: string
  showLabel?: boolean
  initialSelectedOutletId?: string
  productId?: string
  includeAvailability?: boolean
  portalTargetRef?: RefObject<HTMLDivElement>
  onOutletChange?: (outlet: OutletOption) => void
  onSelectedOutletIdChange?: (outletId?: string) => void
}

export type AvailabilityBadgeAppearance = typeof AVAILABILITY_BADGE_APPEARANCES[keyof typeof AVAILABILITY_BADGE_APPEARANCES]

export type OutletDropdownListOption = DropdownListOption

type OutletSelectDropdownListProps = ComponentProps<typeof DropdownList> &
  UseDropdownListProps

export const OutletSelectDropdownList = DropdownList as FC<OutletSelectDropdownListProps>
